<header class="main__content__header modal-header">
    <h2 class="modal-title">Detalhes Análise de Pagamento</h2>
    <a class="header__btn__close" (click)="activeModal.close(true)">
        <span aria-hidden="true">X</span>
    </a>
</header>
<main class="modal-body m-2">
    <section class="content__resultado__grid__main mb-2">
        <section class="content__header__table">
            <div class="col-12">Dados do pagamento</div>
        </section>
        <section class="content__main__table row">
            <div class="col-6 px-2 table__card">
                <span>Referência:</span>
                <span class="table__card__valor">{{paymentAnalyze.reference}}</span>
            </div>
            <div class="col-6 px-2 table__card">
                <span>Data de Pagamento:</span>
                <span class="table__card__valor">{{paymentAnalyze.paymentDate | date: 'dd/MM/yyyy'}}</span>
            </div>
        </section>
    </section>
    <section class="content__resultado__grid__main mb-2">
        <section class="content__header__table">
            <div class="col-12">Dados do participante</div>
        </section>
        <section class="content__main__table">
            <section class="col-12 px-0 row">
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 px-2 table__card">
                    <span>Nome:</span>
                    <span class="table__card__valor">{{paymentAnalyze.name}}</span>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 px-2 table__card">
                    <span>Registro/Matrícula:</span>
                    <span class="table__card__valor">{{paymentAnalyze.register}}</span>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 px-2 table__card">
                    <span>CPF:</span>
                    <span class="table__card__valor">{{paymentAnalyze.cpf}}</span>
                </div>
            </section>
            <div class="col-12 px-2 table__card">
                <span>Beneficiário:</span>
                <span class="table__card__valor">{{paymentAnalyze.beneficiary}}</span>
            </div>
            <div class="col-12 px-2 table__card">
                <span>Dependentes IR:</span>
                <span class="table__card__valor">{{paymentAnalyze.dependentIR}}</span>
            </div>
        </section>
    </section>
    <section class="content__resultado__grid__main mb-2">
        <section class="content__header__table">
            <div class="col-12">Dados bancários</div>
        </section>
        <section class="content__main__table row">
            <div class="col-4 px-2 table__card">
                <span>Banco:</span>
                <span class="table__card__valor">{{paymentAnalyze.bank || ' - '}}</span>
            </div>
            <div class="col-4 px-2 table__card">
                <span>Agência: </span>
                <span class="table__card__valor">{{paymentAnalyze.agency || ' - '}}</span>
            </div>
            <div class="col-4 px-2 table__card">
                <span>Conta: </span>
                <span class="table__card__valor">{{paymentAnalyze.account || ' - '}}</span>
            </div>
        </section>
    </section>
    <section class="row">
        <section class="col-xl-6 col-lg-6 col-md-6 col-sm-12 px-1 content__resultado__grid__main mb-2 px-0">
            <section class="content__header__table">
                <div class="col-12">Vantagens</div>
            </section>
            <section class="content__main__table">
                <div class="col-12 px-2 table__card">
                    <span>Referência:</span>
                    <span class="table__card__valor">{{paymentAnalyze.reference}}</span>
                </div>
                <section class="row">
                    <div class="col-4 px-2 table__card">
                        <span>Verba</span>
                    </div>
                    <div class="col-4 px-2 table__card">
                        <span>Descrição</span>
                    </div>
                    <div class="col-4 px-2 table__card">
                        <span>Valor</span>
                    </div>
                </section>
                <section class="row" *ngFor="let payment of paymentAnalyze.paymentItems">
                    <div class="col-4 px-2 table__card">
                        <span>{{payment.code}}</span>
                    </div>
                    <div class="col-4 px-2 table__card table__card__descricao">
                        <span>{{payment.description}}</span>
                    </div>
                    <div class="col-4 px-2 table__card">
                        <span>{{payment.value | currency:'BRL'}}</span>
                    </div>
                </section>
                <section class="row">
                    <div class="col-8 px-2 table__card">
                        <span>Valor Total: </span>
                    </div>
                    <div class="col-4 px-2 table__card">
                        <span>{{paymentAnalyze.paymentTotal | currency:'BRL'}}</span>
                    </div>
                </section>
            </section>
        </section>
        <section class="col-xl-6 col-lg-6 col-md-6 col-sm-12 px-1 content__resultado__grid__main mb-2">
            <section class="content__header__table">
                <div class="col-12">Descontos</div>
            </section>
            <section class="content__main__table">
                <div class="col-12 px-2 table__card">
                    <span>Referência:</span>
                    <span class="table__card__valor">{{paymentAnalyze.reference}}</span>
                </div>
                <section class="row content-table">
                    <div class="col-4 px-2 table__card">
                        <span>Verba</span>
                    </div>
                    <div class="col-4 px-2 table__card">
                        <span>Descrição</span>
                    </div>
                    <div class="col-4 px-2 table__card">
                        <span>Valor</span>
                    </div>
                </section>
                <section class="row content-table" *ngFor="let descontPayment of paymentAnalyze.descontPaymentItems">
                    <div class="col-4 px-2 table__card">
                        <span>{{descontPayment.code}}</span>
                    </div>
                    <div class="col-4 px-2 table__card table__card__descricao">
                        <span>{{descontPayment.description}}</span>
                    </div>
                    <div class="col-4 px-2 table__card">
                        <span>{{descontPayment.value | currency:'BRL'}}</span>
                    </div>
                </section>
                <section class="row">
                    <div class="col-8 px-2 table__card">
                        <span>Valor Total: </span>
                    </div>
                    <div class="col-4 px-2 table__card">
                        <span class="table__card__valor">{{paymentAnalyze.descontPaymentTotal | currency:'BRL'}}</span>
                    </div>
                </section>
                <section class="row">
                    <div class="col-8 px-2 table__card">
                        <span>Valor Líquido: </span>
                    </div>
                    <div class="col-4 px-2 table__card">
                        <span class="table__card__valor">{{paymentAnalyze.paymentMinusDescontTotal |
                            currency:'BRL'}}</span>
                    </div>
                </section>
            </section>
        </section>
    </section>
    <section class="content__resultado__grid__main mb-2">
        <ng-template #naoPossuiReferenciaMensalidade>
            <div class="col-12 px-2 table__card">
                <span>Neste mês de referência não houveram mensalidades</span>
            </div>
        </ng-template>
        <section class="content__header__table">
            <div class="col-12">Mensalidades</div>
        </section>
        <section class="content__main__table">
            <section class="row">
                <div class="col-4 px-2 table__card">
                    <span>Beneficiário</span>
                </div>
                <div class="col-2 px-2 table__card">
                    <span>Faixa Etária</span>
                </div>
                <div class="col-3 px-2 table__card">
                    <span>Valor Total</span>
                </div>
                <div class="col-3 px-2 table__card">
                    <span>Valor do Beneficiário</span>
                </div>
            </section>
            <ng-template
                *ngIf="paymentAnalyze.monthlyHealthResumeItems && paymentAnalyze.monthlyHealthResumeItems.length!=0 else naoPossuiReferenciaMensalidade">
                <section class="row" *ngFor="let monthlyHealthResume of paymentAnalyze.monthlyHealthResumeItems">
                    <div class="col-4 px-2 table__card">
                        <span>{{monthlyHealthResume.beneficiary}}</span>
                    </div>
                    <div class="col-2 px-2 table__card">
                        <span>{{monthlyHealthResume.groupAge}}</span>
                    </div>
                    <div class="col-3 px-2 table__card">
                        <span>{{monthlyHealthResume.totalValue | currency:'BRL'}}</span>
                    </div>
                    <div class="col-3 px-2 table__card">
                        <span>{{monthlyHealthResume.beneficiaryValue | currency:'BRL'}}</span>
                    </div>
                </section>
            </ng-template>
        </section>
    </section>
    <section class="content__resultado__grid__main mb-2">
        <section class="content__header__table">
            <div class="col-12">Saldos devedor de saúde</div>
        </section>
        <section class="content__main__table">
            <section class="row">
                <div class="col-6 px-2 table__card">
                    <span>Data do Débito: </span>
                    <span class="table__card__valor"> </span>
                </div>
                <div class="col-6 px-2 table__card ">
                    <span>Valor</span>
                    <span class="table__card__valor"></span>
                </div>
            </section>
            <ng-template
                *ngIf="paymentAnalyze.healthDebitItems && paymentAnalyze.healthDebitItems.length!=0 else naoPossuiSaldoSaude">
                <section class="row" *ngFor="let healthDebit of paymentAnalyze.healthDebitItems">
                    <div class="col-6 px-2 table__card">
                        <span>{{healthDebit.paymentDate | date: 'dd/MM/yyyy'}}</span>
                    </div>
                    <div class="col-6 px-2 table__card">
                        <span>{{healthDebit.value | currency:'BRL'}}</span>
                    </div>
                </section>
            </ng-template>
            <ng-template #naoPossuiSaldoSaude>
                <div class="col-12 px-2 table__card">
                    <span>Neste mês de referência não houve saldo devedor de saúde</span>
                </div>
            </ng-template>
        </section>
    </section>
    <section class="content__resultado__grid__main mb-2">
        <section class="content__header__table">
            <div class="col-12">Saldos devedor de Empréstimos</div>
        </section>
        <section class="content__main__table">
            <section class="row">
                <div class="col-4 px-2 table__card">
                    <span>Descrição</span>
                </div>
                <div class="col-4 px-2 table__card">
                    <span>Parcelas Restantes</span>
                </div>
                <div class="col-4 px-2 table__card">
                    <span>Valor</span>
                </div>
            </section>
            <section class="row" *ngIf="paymentAnalyze.loan else naoPossuiEmprestimos">
                <div class="col-4 px-2 table__card">
                    <span class="table__card__valor">{{paymentAnalyze.loan.description}}</span>
                </div>
                <div class="col-4 px-2 table__card">
                    <span class="table__card__valor">{{paymentAnalyze.loan.leftPays}}</span>
                </div>
                <div class="col-4 px-2 table__card">
                    <span class="table__card__valor">{{paymentAnalyze.loan.leftValueToPay | currency:'BRL'}}</span>
                </div>
            </section>
            <ng-template #naoPossuiEmprestimos>
                <div class="col-12 px-2 table__card">
                    <span>Neste mês de referência não há saldo devedor de empréstimos</span>
                </div>
            </ng-template>
        </section>
    </section>
</main>
<footer class="modal-footer">
    <button class="btn btn-primary" (click)="exportToPDF()" id="null" *ngIf="showButton">
        <ng-template #showSpan>
            <span>Exportar para PDF</span>
        </ng-template>
        <div class="d-flex" style="align-items: center; justify-content: center;" *ngIf="loading; else showSpan">
            <span class="spinner">
            </span>
        </div>
    </button>
</footer>